/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ConversationArchivingReasonEnum =
  (typeof ConversationArchivingReasonEnum)[keyof typeof ConversationArchivingReasonEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConversationArchivingReasonEnum = {
  not_available: 'not_available',
  dog_not_good_fit: 'dog_not_good_fit',
  owner_not_good_fit: 'owner_not_good_fit',
  owner_didnt_respond: 'owner_didnt_respond',
  owners_plans_changed: 'owners_plans_changed',
  duplicate_message: 'duplicate_message',
  owner_found_another_sitter: 'owner_found_another_sitter',
  outside_service_radius: 'outside_service_radius',
  sitter_not_available: 'sitter_not_available',
  sent_by_mistake: 'sent_by_mistake',
  found_another_pet_care: 'found_another_pet_care',
  sitter_never_replied: 'sitter_never_replied',
  unmet_needs: 'unmet_needs',
  pet_care_no_longer_needed: 'pet_care_no_longer_needed',
  inappropriate_behaviour: 'inappropriate_behaviour',
  too_expensive: 'too_expensive',
} as const;
